import { selectors } from './selectors'
import { initBackButtons } from './shared'
import { variantSelectorDrawer } from './drawer-variant'
import { openDrawer, closeDrawer } from '../../drawer';
import { getProductItemsTotalCount, updateItemCount } from '../../../pages/cart';
import { gtmChangeCart } from '../../../helpers/gtm/gtmChangeCart';
import { getGtmCollections, getGtmTags, getGtmAvailability } from '../../../helpers/gtm/gtmUtils';
import {getCart} from '../../../../components/cart-section/js/utils';
import { createServiceProps } from "../../../utils/props";

import {
  GTM_ATTRIBUTE_PRODUCT_COLLECTIONS,
  GTM_ATTRIBUTE_PRODUCT_TAGS,
  GTM_ATTRIBUTE_PRODUCT_RATING,
  GTM_ATTRIBUTE_PRODUCT_REVIEWS,
  GTM_SELECTOR_PRODUCT_AVAILABILITY,
  GTM_SELECTOR_PRODUCT_ID,
  GTM_SELECTOR_PRODUCT_TITLE,
} from '../../../helpers/gtm/gtmSelectors';

const fetchCart = async items => {
  const url = window.location.origin + items[0].url + "&view=atc-drawer"
  const response = await fetch(url)

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`)
  }
  const data = await response.text()
  return data
}

const initAccordions = () => {
  const accordions = document.querySelectorAll(selectors.atcDrawerService);
  accordions.forEach(accordion => {
    const open = accordion.querySelector(selectors.atcDrawerServiceOpen);
    open.addEventListener("click", e => {
      accordion.setAttribute("open", "");
    });
    const close = accordion.querySelector(selectors.atcDrawerServiceClose);
    close.addEventListener("click", e => {
      accordion.removeAttribute("open");
    });
  });
};


const addServiceToCart = async (id, checkbox) => {
  const title = document.querySelector(selectors.atcDrawer).getAttribute('data-product-title')
  const productIdAttachedToService = document.querySelector(selectors.atcDrawer).getAttribute('data-product-id')
  const formData = {
    items: [
      {
        id: Number(id),
        quantity: 1,
        properties: {
          "Product Name": `${title}`,
          "Service": true,
          _isService: true,
          _productId: productIdAttachedToService
        }
      }
    ],
  };

  console.log(`Adding the following services to cart: ${JSON.stringify(formData)}`);

  try {
    const data = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    });
    const response = await data.json()
    if (response != null && response.items != null && response.items?.length != 0) {
      checkbox.setAttribute("item-id", response.items[0].key)
    }
  } catch (error) {
    console.error('There was a problem with the fetch operation: ', error);
  }
}

const removeServiceFromCart = async id => {
  const service = {
    'id': id,
    'quantity': 0
  }
  await fetch(window.Shopify.routes.root + "cart/change.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(service)
  })
}

const updateLineitemWithService = async (item, servicesHandles) => {
  try {
    await window.shopifyFrontendHelper.updateCartItem({
      id: item[0].key,
      properties: {
        Sluzby: servicesHandles.join(", "),
        addedServices: servicesHandles,
      },
      quantity: item[0].quantity
    });
    if (window.sections.cart_section) {
      window.sections.cart_section.refresh()
    }
  } catch {
    console.error("Error removing service from cart");
  }
}

const	initCheckboxes = (product) => {
  const checkboxes = document.querySelectorAll(selectors.atcDrawerServiceCheckbox)
  let servicesHandles = []
  checkboxes.forEach(checkbox => {
    checkbox.addEventListener("click", async function(e) {
      if (checkbox.classList.contains('disabled')) return
      if (checkbox.hasAttribute("checked")) {
        await removeServiceFromCart(checkbox.getAttribute("item-id"))
        checkbox.removeAttribute("checked")
        servicesHandles = servicesHandles.filter(handle => handle !== checkbox.getAttribute("service-handle"))
      } else {
        await addServiceToCart(checkbox.getAttribute("service-id"), checkbox)
        checkbox.setAttribute("checked", "")
        servicesHandles.push(checkbox.getAttribute("service-handle"))
      }
      const mainProductId = checkbox.dataset.productId
      const cartItems = await getCart(true)
      const item = cartItems.filter(cartItem => cartItem.variant_id == mainProductId)
      await updateLineitemWithService(item, servicesHandles)
    })
  })
}

const renderAtcDrawer = async items => {
  return new Promise(async (resolve, reject) => {
    try {
      const data = await fetchCart(items);
      const drawerElement = document.querySelector('[data-js-selector="atc-product"]')
      const parsedData = new DOMParser().parseFromString(data, 'text/html')

      // Check if the cart drawer is enabled in the customizer
      if (window.sga.cartDrawer === 'true') {
        drawerElement.innerHTML = parsedData.querySelector('[data-js-selector="atc-product"]').innerHTML
        drawerElement.classList.remove('drawer--atc__variants')
      } else if (drawerElement.classList.contains('is-open')) {
        // If the variant drawer is open, close it
        closeDrawer(drawerElement);
      }

      const cartData = JSON.parse(parsedData.querySelector('[js-cart-data]').innerHTML)
      const productItemsTotalCount = getProductItemsTotalCount(cartData);
      updateItemCount("cart", productItemsTotalCount);
      updateItemCount("wishlist", productItemsTotalCount);
      setTimeout(() => {
        window.sga.cartDrawer === 'true' ? openDrawer(drawerElement) : null;
        resolve();
        const freeReturnCheckbox = Array.from(document.querySelectorAll(selectors.atcDrawerServiceCheckbox)).filter(el => el.getAttribute('checked') != null )
        freeReturnCheckbox.forEach( async el => {
          await addServiceToCart(el.getAttribute("service-id"), el)
        })
      }, 10)

    } catch (error) {
      console.error("Error:", error);
      reject(error);
    }
  });
};

const initRecommendations = async () => {
  const productRecommendationsSection = document.querySelector(selectors.atcDrawerProductRecommendations)
  if (!productRecommendationsSection) return;
  await fetch(productRecommendationsSection.dataset.url)
    .then((response) => response.text())
    .then((text) => {
      const html = document.createElement('div');
      html.innerHTML = text;
      const recommendations = html.querySelector(selectors.atcDrawerProductRecommendations);

      if (recommendations && recommendations.innerHTML.trim().length) {
        productRecommendationsSection.innerHTML = recommendations.innerHTML;
        const el = document.querySelector(selectors.atcDrawerProductRecommendationsSlider)
        setTimeout(() => {
          new BlazeSlider(el, {
            all: {
              draggable: false,
              loop: true,
              slidesToShow: 3,
              slideGap: '25px',
            }
          })
          productRecommendationsSection.querySelector(selectors.atcDrawerProductRecommendationsSlider)
            .setAttribute('data-gtm-product-list-view', `drawer-product-recommendations`);
          window.sga.triggerGtmProductsObserver(`#${productRecommendationsSection.id}`);
          const addVariantToCartButtons = productRecommendationsSection.querySelectorAll(selectors.atcProductButton);
          addVariantToCartButtons.forEach(btn => {
            btn.addEventListener('click', async e => {
              addVariantToCart(btn)
            })
          })
          const selectVariantButtons = productRecommendationsSection.querySelectorAll(selectors.atcProductWithVariantsButton)
          selectVariantButtons.forEach(btn => {
            btn.addEventListener('click', async e => {
              variantSelectorDrawer(btn.getAttribute('js-atc-product-with-variants'))
            })
          })
        }, 1000);
      }
    })
    .catch((e) => {
      console.error(e);
    });
}

export const main = async items => {
  try {
    await renderAtcDrawer(items);
    initCheckboxes(items[0]);
    initAccordions();
    initBackButtons();
    if (window.sections.cart_section) {
      await window.sections.cart_section.refresh();
    }
    await initRecommendations();
  } catch (error) {
    console.error("Error:", error);
  }
};

export const addVariantToCart = async (element, quantity = 1, idValue = null) => {
  const id = idValue ?? element?.getAttribute('js-atc-product');
  const productElement = element.closest(GTM_SELECTOR_PRODUCT_ID);
  const collections = getGtmCollections(productElement?.getAttribute(GTM_ATTRIBUTE_PRODUCT_COLLECTIONS));
  const tags = getGtmTags(productElement?.getAttribute(GTM_ATTRIBUTE_PRODUCT_TAGS));
  const rating = Number(productElement?.getAttribute(GTM_ATTRIBUTE_PRODUCT_RATING));
  const reviews = Number(productElement?.getAttribute(GTM_ATTRIBUTE_PRODUCT_REVIEWS));
  const availability = getGtmAvailability(productElement.querySelectorAll(GTM_SELECTOR_PRODUCT_AVAILABILITY));
  const title = productElement.querySelector(GTM_SELECTOR_PRODUCT_TITLE)?.innerText;

  try {
    const cart = await window.shopifyFrontendHelper.addToCart([{
      id: Number(id),
      quantity,
      properties: {
        ...createServiceProps(title),
        _analytics_data: {
          flags: tags,
          availability,
          categories: collections,
          rating,
          reviews,
        }
      }
    }]);

    if (cart?.items) {
      main(cart.items);
      gtmChangeCart([id], quantity, 'drawer-product');
    } else {
      if (cart?.description) {
        alert(cart.description);
      }
    }

    document.dispatchEvent(
      new CustomEvent("cart:updated")
    );
  } catch (e) {
    console.error("Error adding to cart", e);
  }
}

const handleAtc = async e => {
  const items = e.detail.items
  main(items)
}

document.addEventListener("cart:updated", handleAtc)

const addVariantToCartButtons = document.querySelectorAll(selectors.atcProductButton)
addVariantToCartButtons.forEach(btn => {
  btn.addEventListener('click', async e => {
    addVariantToCart(btn)
  })
})
